module.exports = __webpack_public_path__ + "img/1100_3_PhysicalSecurity.34e3258c.png";